import { View } from "react-native";
import { GatheringContext } from "src/contexts/GatheringContext/GatheringContext";
import { useInsideModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import { paddingLarge } from "src/styles/spacing";
import GatheringViewersList from "./components/GatheringViewersList";
import { useGatheringViewersModalDimensions } from "./GatheringViewersModalSkeleton";

const GatheringViewersModal = () => {
	const {
		props: { gatheringId, context },
	} = useInsideModal<GatheringModal["GatheringViewers"]>();
	const style = useGatheringViewersModalDimensions();

	return (
		<GatheringContext.Provider value={context}>
			<View
				style={[
					style,
					{
						paddingTop: paddingLarge,
					},
				]}
			>
				<GatheringViewersList gatheringId={gatheringId} />
			</View>
		</GatheringContext.Provider>
	);
};
export default GatheringViewersModal;
